import React, { useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

/**
 * Higher-order component to inject `setIsLoading` function into wrapped component.
 * Renders either the component or a Skeleton loading animation.
 * @param {React.ReactNode} WrappedComponent component to be injected
 * @returns wrapped version of `WrappedComponent`
 */
const withComponentLoader = WrappedComponent => {
	const HOC = props => {
		const [isLoading, setIsLoading] = useState(true);

		const setLoadingState = isComponentLoading => {
			setIsLoading(isComponentLoading);
		};

		const contents = (
			<WrappedComponent {...props} setLoading={setLoadingState} />
		);

		return isLoading ? (
			<Skeleton width='100%'>{contents}</Skeleton>
		) : (
			<>{contents}</>
		);
	};
	return HOC;
};

export default withComponentLoader;
